/**
 * @param {*} permitedRole -> role permitted to access route
 * @param {*} userRole -> currentRole user at
 * @param {*} formRoute -> for debug what route is being checking, call it as parameter only when needed
 * @returns 
 */

export const checkPermission = (permittedRole, userRole) => {

  // If route doesn't has permittedRole return true
  if (!permittedRole || !permittedRole) {
    return true;
  }
  // if userRole is exist and is array, and permittedRole is not an array
  if (userRole && Array.isArray(userRole) && !Array.isArray(permittedRole)) {
    return userRole.indexOf(permittedRole) >= 0;  // find index of permittedRole value in userRole
  }
  // if permittedRole is array and its length is empty
  if (permittedRole.length === 0) {
    return !userRole || userRole.length === 0;
  }
  // if both is array
  if (userRole && Array.isArray(userRole) && Array.isArray(permittedRole)) {
    return permittedRole.some((r) => userRole.indexOf(r) >= 0);
  }
  // if both is string
  if (typeof permittedRole === 'string' && typeof userRole === 'string') {
    return permittedRole === userRole
  }

  // default if permittedRole is array and userRole is not an array
  return permittedRole.indexOf(userRole.label) >= 0;
};